import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = {
  key: 0,
  ref: "panoramaElement",
  class: "w-100 h-100"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column w-100 h-100 justify-content-center"
}
const _hoisted_4 = { class: "alert alert-warning text-center" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.panoramaAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, null, 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("p", null, " Panorama pro tuto lokalitu není k dispozici ", -1)),
            _createElementVNode("a", {
              href: `https://mapy.cz/zakladni?source=coor&id=${_ctx.longitude},${_ctx.latitude}`,
              target: "_blank",
              title: "Zobrazit na webu Mapy.cz"
            }, " Zobrazit na webu Mapy.cz ", 8, _hoisted_5)
          ])
        ]))
  ]))
}